import * as React from 'react';
import { Alert } from 'react-bootstrap';

interface IProps {
    message: string
}

const NoData: React.FunctionComponent<IProps> = (props) => {
    return (
        <div style={{ padding: '1%' }}>
            <Alert bsStyle='info' style={{ textAlign: 'center', padding: 7.5 }}>{props.message}</Alert>
        </div>
    );
}

export default NoData;